<template>
  <div class="product-info__card mb-2">
    <div class="card__wrapper">
      <div class="img__wrapper">
        <div class="img">
          <el-image
            :src="
              item.defaultImageUrl
                ? $osscdn(item.defaultImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            :preview-src-list="[
              item.defaultImageUrl
                ? $osscdn(item.defaultImageUrl)
                : '/image/static/img/nopic.jpg',
            ]"
            fit="cover"
            style="width: 148px; height: 148px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 148px; height: 148px"
              />
            </div>
          </el-image>
        </div>
        <div class="mt-2" v-if="!disabled">
          <el-button
            class="w-full"
            type="primary"
            plain
            size="mini"
            @click="uploadImage"
            >{{ $l('btn_img_edit') || '图片编辑' }}</el-button
          >
        </div>
        <div class="mt-2 button_group" v-if="!disabled">
          <el-button plain size="mini" @click="$emit('del', item)">{{
            $l('INDEX.btn_tips_del') || '删除'
          }}</el-button>
          <el-button plain size="mini" @click="$emit('edit', item)">{{
            $l('INDEX.btn_tips_edit') || '编辑'
          }}</el-button>
        </div>
      </div>
      <div class="flex-1">
        <div>
          <el-form ref="form" :model="item" size="mini" label-position="top">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$l('form_label_sample_style_no') || '产品款号'">
                  <el-input v-model="item.masterSampleStyleNo" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item :label="$l('form_label_sample_name') || '中文名称'">
                  <el-input v-model="item.masterSampleName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item :label="$l('form_label_sample_name_en') || '英文名称'">
                  <el-input v-model="item.masterSampleNameEn" readonly />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$l('form_label_color_name') || '中文颜色'">
                  <el-input v-model="item.colorName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$l('form_label_color_name_en') || '英文颜色'">
                  <el-input v-model="item.colorNameEn" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$l('form_label_goods_size') || '产品尺寸'">
                  <el-input v-model="item.goodsSizeSpec" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$l('form_label_category_name') || '产品类别'">
                  <el-input v-model="item.categoryName" readonly />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item :label="$l('form_label_is_single') || '是否套装'">
                  <el-input v-model="item.v_isSingle" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$l('form_label_unit_price') || '样品单价（CNY）'">
                  <el-input v-model="item.unitPrice" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$l('form_label_qty') || '打样数量'">
                  <el-input v-model="item.qty" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$l('form_label_sample_amount') || '样品费用（CNY）'">
                  <el-input v-model="item.sampleAmount" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$l('form_label_add_surcharge') || '附加费（CNY）'">
                  <el-input v-model="item.addSurcharge" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$l('form_label_sub_amount') || '小计金额（CNY）'">
                  <el-input v-model="item.subAmount" readonly />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <FabricTable
            ref="fabricTable"
            :proofingSampleCode="item.proofingSampleCode"
            v-if="isSingle"
          />
          <SpecTable
            ref="specTable"
            :proofingSampleCode="item.proofingSampleCode"
            v-else
          />
        </div>
      </div>
    </div>
    <ImageChoose
      :proofingCode="item.proofingCode"
      :visible.sync="showImageChoose"
      v-if="showImageChoose"
      :title="$l('INDEX.evg_sku_label_image_maintenance') || '图片维护'"
      @setImage="setImage"
    >
    </ImageChoose>
  </div>
</template>
<script>
import FabricTable from './fabric-table'
import SpecTable from './spec-table'
import ImageChoose from './image-choose'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { FabricTable, SpecTable, ImageChoose },
  mixins: [EditLoading],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      showImageChoose: false,
    }
  },
  methods: {
    reloadTable() {
      const ft = this.$refs.fabricTable
      if (ft) {
        ft.getData()
      }
      const st = this.$refs.specTable
      if (st) {
        st.getData()
      }
    },
    async uploadImage() {
      this.showImageChoose = true
    },
    async setImage({ displayImageCode, displayImageUrl }) {
      this.loadingOpen()
      const params = {
        defaultImageUrl: displayImageUrl,
        defaultImageCode: displayImageCode,
        proofingSampleCode: this.item.proofingSampleCode,
      }
      const saveRes = await this.$api
        .customerProofingSampleImgApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!saveRes) return
      const { status } = saveRes
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.showImageChoose = false
      this.$emit('reload')
    },
  },
  computed: {
    isSingle() {
      return this.item.isSingle === 'Y'
    },
  },
}
</script>
<style lang="scss" scoped>
.product-info__card {
  border-radius: 5px;
  border: 1px dotted #bbbbbb;
  padding: 10px;
  .card__wrapper {
    display: flex;
    .img__wrapper {
      width: 154px;
      margin-right: 10px;
      > .img {
        width: 150px;
        height: 150px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        > .el-image {
          border-radius: 4px;
        }
      }
    }
  }
}
.button_group {
  display: flex;
  justify-content: space-between;
  > button {
    border-radius: 3px !important;
  }
}
.w-full {
  width: 100% !important;
}
.flex-1 {
  flex: 1;
}
</style>
